import { InfiniteData } from '@tanstack/react-query';

import { IOfferSchema } from 'shared/repositories/commercial-search-offers/entities/offer/OfferSchema';
import { IPublicDesktopV2GetSimilarOffersResponseSchema } from 'shared/repositories/commercial-search-offers/entities/response/PublicDesktopV2GetSimilarOffersResponseSchema';

export function infiniteOffersDataToOffers(
  data: InfiniteData<IPublicDesktopV2GetSimilarOffersResponseSchema>,
): IOfferSchema[] {
  return data.pages.flatMap(page => page.offers);
}
